function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21995",
    transform: "translate(-1246 -411)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5043",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(1246 411)",
    style: {
      fill: "#0c831f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "check (2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16313",
    d: "M20.692 58.83 9.447 70.074a2.134 2.134 0 0 1-3.017 0L.624 64.269a2.133 2.133 0 0 1 3.017-3.017l4.3 4.3 9.736-9.736a2.133 2.133 0 0 1 3.017 3.017z",
    transform: "translate(1260.342 373.057)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenChecked);
export default __webpack_public_path__ + "static/media/green_checked.d14cd3a4aabc1507b798a71cbbea1e53.svg";
export { ForwardRef as ReactComponent };